import { render, staticRenderFns } from "./TaskEdit1.vue?vue&type=template&id=5bb8953a&scoped=true&"
import script from "./TaskEdit1.vue?vue&type=script&lang=js&"
export * from "./TaskEdit1.vue?vue&type=script&lang=js&"
import style0 from "./TaskEdit1.vue?vue&type=style&index=0&id=5bb8953a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8953a",
  null
  
)

export default component.exports